import { render } from "./feedback.vue?vue&type=template&id=1b7b2d0a&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"

import "./feedback.vue?vue&type=style&index=0&id=1b7b2d0a&scoped=true&lang=css"

import exportComponent from "F:\\Vuedemo\\element-便签\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7b2d0a"]])

export default __exports__